import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import { Page, Loadable, Fab } from "components/support";
import { colors, Icon } from "assets";

import Filter from "./filter";
import Chart from "./chart";
import Revenues from "./revenues";
import DataTable from "./data-table";

class MultilocalitySalesReportView extends Component {
  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  render() {
    const { viewModel, presenter } = this.props;
    const {
      loading,
      filters,
      chartData,
      totalRevenues,
      results,
      pagination,
      order,
      companySearchOptions
    } = viewModel;
    const { defaultLoading } = loading;

    return (
      <Page>
        <Loadable loading={defaultLoading}>
          <Typography type="display1" className="pb-sm">
            Relatório de Vendas Multilojas
          </Typography>

          <Row className="mb-sm">
            <Col xs={12}>
              <Filter
                filters={filters}
                companySearchOptions={companySearchOptions}
                onChange={filters => presenter.onFilterChange(filters)}
              />
            </Col>
          </Row>

          <Row className="mt-sm">
            <Col xs={12} md={6}>
              <Chart chartData={chartData} />
            </Col>
            <Col xs={12} md={6}>
              <Revenues totalRevenues={totalRevenues} />
            </Col>
          </Row>

          <Row className="mt-sm pb-lg">
            <Col xs={12}>
              <Paper elevation={1}>
                <DataTable
                  results={results}
                  pagination={pagination}
                  order={order}
                  onOrderChange={(order, value) =>
                    presenter.onOrderChange(order, value)
                  }
                  onPageChange={page => presenter.onPageChange(page)}
                />
              </Paper>
            </Col>
          </Row>

          {this.downloadButton()}
        </Loadable>
      </Page>
    );
  }
}

export default MultilocalitySalesReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/views.jsx